
import { Company } from "@/models/company";
import { CompanyModule } from "@/models/company-module";
import Vue from "vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>CompanyModule,
			required: true
		},
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},

	methods: {
		cancel(){
			this.$emit("close");
		},
		//custom esc Button event
		escButtonEvent(ev:KeyboardEvent){
			if (ev.key === "Escape") {
				this.cancel();
			}
			return;
		}
	},
	mounted() {
		window.addEventListener("keyup",this.escButtonEvent);
	},
	beforeDestroy(){
		window.removeEventListener("keyup", this.escButtonEvent);
	}
});
